document.addEventListener('DOMContentLoaded', () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if (window.location.search != "" ) {
    document.body.classList.add('filter-active')
  }

  if (params.fcategory != null || params.frange != null || params.fcolour != null) {
    var nextElems = document.querySelectorAll('.next-item')
    for (let i = 0; i < nextElems.length; i++) {
      const element = nextElems[i];
      element.style.display = "none"
    }
  }

  let category = params.fcategory;
  let categoryValues = null
  if (category != null ){
    categoryValues = category.split(',');
  } 
  var collections = document.querySelectorAll('.collection-section')
  
  for (let l = 0; l < collections.length; l++) {
    let collection = collections[l]
    let collectionCategory = collection.getAttribute('data-category')
    if (categoryValues != null) {
      var found = false

      for (let j = 0; j < categoryValues.length; j++) {
        document.querySelector(`[${categoryValues[j]}]`).classList.add('active')

        if (collectionCategory != categoryValues[j]  && found == false ) {
          collection.style.display="none"
        } else {
          collection.style.display="grid"
          found = true 
        }
      }
    }

  }

  let range = params.frange;
  let rangeValues = null
  if (range != null ){
    rangeValues = range.split(',');
  }
  let colour = params.fcolour;
  let colourValues = null
  if (colour != null ){
    colourValues = colour.split(',');
  }

  let productTiles = document.querySelectorAll('.product-tile')
  for (let i = 0; i < productTiles.length; i++) {
    let productTile = productTiles[i]
    let productRange = productTile.getAttribute('data-range')
    let productColour = productTile.getAttribute('data-colour')
    var foundColour = false
    var foundRange = false
  
    if (rangeValues != null && colourValues != null) {
      for (let j = 0; j < rangeValues.length; j++) {
        document.querySelector(`[${rangeValues[j]}]`).classList.add('active')

        if (productRange != rangeValues[j] && foundRange == false) {
          productTile.style.display="none"
        } else {
          productTile.style.display="block"
          foundRange = true 
        }
      }
      for (let k = 0; k < colourValues.length; k++) {
        document.querySelector(`[${colourValues[k]}]`).classList.add('active')
        if (productColour != colourValues[k]  && foundColour == false) {
          productTile.style.display="none"
        } else {
          productTile.style.display="block"
          foundColour = true 
        }
      }
    } else if (rangeValues != null) {
      var found = false

      for (let j = 0; j < rangeValues.length; j++) {
        
        document.querySelector(`[${rangeValues[j]}]`).classList.add('active')
        if (productRange != rangeValues[j]  && found == false) {
          productTile.style.display="none"
        } else {
          productTile.style.display="block"
          found = true 
        }
      }
    } else if (colourValues != null) {
        var found = false
        for (let k = 0; k < colourValues.length; k++) {

        document.querySelector(`[${colourValues[k]}]`).classList.add('active')
        if (productColour != colourValues[k] && found == false) {
          productTile.style.display="none"
        } else {
          productTile.style.display="block"
          found = true 
        }
      }
    }
  }

  for (let i = 0; i < collections.length; i++) {
    const collection = collections[i];  
    var currentURL = window.location.href
    
  
  
  
    var collectionProducts = collection.querySelectorAll('.product-tile');
    var showing = false;

    for (let j = 0; j < collectionProducts.length; j++) {
      const product = collectionProducts[j];
      if (product.style.getPropertyValue('display') == "block") {
        showing = true
      }
    }

    if (showing != true && currentURL.includes('/collections/all')) {
      collection.style.display = "none";
    } else if (showing != true && !currentURL.includes('/collections/all')) {
      collection.classList.add('empty-search')
    }
  }

  var variantSelectors = document.querySelectorAll('.product-tile__variant-row')
  for (let index = 0; index < variantSelectors.length; index++) {

    const element = variantSelectors[index];
    element.addEventListener('mouseenter', (e) => {
      var tile = e.target.closest('.product-tile__hover-content')
      var priceCont = tile.querySelector('.product-tile__var-price')
      var priceContComp = tile.querySelector('.product-tile__var-compare-price')
      var price = e.target.getAttribute('data-varPrice')
      var compprice = e.target.getAttribute('data-varComparePrice')
      tile.classList.add('varActive')
    
      priceCont.innerHTML = price
      priceContComp.innerHTML = compprice
    })

    element.addEventListener('mouseleave', (e) => {
      var tile = e.target.closest('.product-tile__hover-content')
      tile.classList.remove('varActive')
      var priceContComp = tile.querySelector('.product-tile__var-compare-price')
      var priceCont = tile.querySelector('.product-tile__var-price')
      priceCont.innerHTML = ''
      pricContComp.innerHTML = ''
    })
  }
})